// Shared HTML-escape helper.
//
// Use esc() on EVERY user-supplied value that gets injected into the DOM via a
// template literal + innerHTML / insertAdjacentHTML. It is safe in both text
// content and quoted attribute values because it also escapes " and '.
//
// The browser decodes these entities back to the original characters when it
// parses the markup, so values later read via .value, .dataset, or FormData
// round-trip unchanged (e.g. a category named `A & B` stored as `A &amp; B`
// reads back as `A & B`). That means escaping never corrupts the stored data -
// it only neutralises markup so a malicious name like `<img onerror=...>` can
// never execute. This is stored-XSS defense: the same Supabase rows are also
// rendered by the admin panel, so an un-escaped name is a cross-surface risk.
export const esc = (v) =>
  String(v ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export default esc;
